/**
 * Serwis zarządzania szablonami faktur
 */

import api from './api';
import { API_URL } from '../config/environment';

export const invoiceTemplatesService = {
  /**
   * Pobierz listę dostępnych szablonów
   */
  async getTemplates() {
    try {
      const response = await api.get('/templates');
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania szablonów:', error);
      throw error;
    }
  },

  /**
   * Pobierz podgląd szablonu z przykładowymi danymi
   */
  async getTemplatePreview(templateName) {
    try {
      const response = await api.get(`/template-preview/${templateName}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Błąd podglądu szablonu:', error);
      throw error;
    }
  },

  /**
   * Pobierz PDF faktury z wybranym szablonem
   */
  async getInvoicePdfWithTemplate(invoiceId, templateName) {
    try {
      const response = await api.get(`/invoice/${invoiceId}/pdf/${templateName}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Błąd generowania PDF faktury:', error);
      throw error;
    }
  },

  /**
   * Pobierz standardowy PDF faktury (bez szablonu)
   */
  async getInvoicePdf(invoiceId) {
    try {
      const response = await api.get(`/sales-invoices/${invoiceId}/pdf`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Błąd pobierania PDF faktury:', error);
      throw error;
    }
  },

  /**
   * Pobierz URL do podglądu szablonu
   */
  getTemplatePreviewUrl(templateName) {
    return `${API_URL}/template-preview/${templateName}`;
  },

  /**
   * Pobierz URL do PDF faktury z szablonem
   */
  getInvoicePdfUrl(invoiceId, templateName) {
    return `${API_URL}/invoice/${invoiceId}/pdf/${templateName}`;
  }
};
